import React, { useState, useEffect } from 'react';
import { X, DeviceMobile } from '@phosphor-icons/react';

export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('hc_pwa_dismissed') === 'true');

  useEffect(() => {
    // Register service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setDeferredPrompt(null);
      setDismissed(true);
      localStorage.setItem('hc_pwa_dismissed', 'true');
    }
  };

  const dismiss = () => {
    setDismissed(true);
    localStorage.setItem('hc_pwa_dismissed', 'true');
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-80 z-50 animate-fade-up" data-testid="pwa-install-prompt">
      <div className="glass-card px-5 py-4 flex items-center gap-4" style={{ borderColor: 'rgba(255,107,53,0.2)' }}>
        <div className="w-10 h-10 rounded-2xl bg-[#FF6B35]/10 flex items-center justify-center flex-shrink-0">
          <DeviceMobile size={20} weight="duotone" className="text-[#FF6B35]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">Install HomeCommand</p>
          <p className="text-[11px] text-neutral-500">Add to home screen for quick access</p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button onClick={install} data-testid="pwa-install-btn"
            className="px-3 py-1.5 rounded-full bg-[#FF6B35] text-white text-xs font-semibold btn-glow">
            Install
          </button>
          <button onClick={dismiss} className="p-1 text-neutral-600 hover:text-neutral-400 transition-colors">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
